/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

import {
  IColumnDef,
  ICustomField,
  IExtendableDto,
  IRydeColumnHelper,
} from "@ryde/shared";

import { useTableColumnBuilders } from "./use-table-def.columns-builders";

interface IUseDynamicTableDefColumns<T extends IExtendableDto> {
  genericColumnHelper: IRydeColumnHelper<T>;
  gridControls: ICustomField[];
}

interface IUseDynamicTableDefColumnsReturn<T extends IExtendableDto> {
  dynamicColumns: IColumnDef<T, any>[];
}

export const useDynamicTableDefColumns = <T extends IExtendableDto>({
  genericColumnHelper,
  gridControls,
}: IUseDynamicTableDefColumns<T>): IUseDynamicTableDefColumnsReturn<T> => {
  const { buildColumnAccessor } = useTableColumnBuilders<T>();

  const dynamicColumns = useMemo(
    () =>
      gridControls.map(control => {
        return buildColumnAccessor({
          control,
          genericColumnHelper,
        });
      }),
    [gridControls, buildColumnAccessor, genericColumnHelper],
  );

  return { dynamicColumns };
};
